import { OfficeComponentContext } from '@office-start/officehome-types';

import { ThemingService } from '../services/theming.service';
import { initializeFluentTheme } from './initialize-fluent-theme';
import { OfficeStartBootstrapperService } from './office-start-bootstrapper.service';

// Initializes fluent design dependencies (themes, etc.) and service data required for office-start components
// Should be a static import executed in any office-start component wrapper
// NOTE: This is not inside office-start-bootstrapper.service as that service is not loaded lazily, but added to app bundle
// TODO: If we ever end up including this in the app bundle, we can combine this with bootstrap-office-start
export function bootstrapOfficeStartComponent(bootstrapper: OfficeStartBootstrapperService, themingService: ThemingService): OfficeComponentContext {
    initializeFluentTheme(themingService.fluentThemeSubscription);
    return bootstrapper.bootstrapOfficeStart();
}
